import React from 'react'
import { useIntl } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { SecondaryButton } from '../../atoms/secondaryButton/SecondaryButton'
import { BodyTextSize, getFontStyles, TextType } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

const AssignmentsNoneContainer = styled(View)<{ theme: ThemeType }>(({ theme: { colors, fontFamilyMetadata } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.backgroundPrimary,
  borderRadius: '12px',
  textAlign: 'center',
  padding: '30px 0',
  ...getFontStyles(colors, fontFamilyMetadata)[TextType.BODY][BodyTextSize.DEFAULT],
}))

const AssignmentsNoneButtonContainer = styled(View)<{
  theme: ThemeType
}>(({ theme }) => ({
  alignSelf: 'center',
  marginTop: theme.spacing['16px'],
}))

export const AssignmentsNone: React.FC<AssignmentsNoneProps> = ({ addActivityHandler, noDataText }) => {
  const intl = useIntl()

  return (
    <AssignmentsNoneContainer>
      <BodyText
        text={
          noDataText ||
          intl.formatMessage({
            defaultMessage: 'No activities for this session',
            description: 'There are no activities in the current session',
          })
        }
      />
      {addActivityHandler && (
        <AssignmentsNoneButtonContainer>
          <SecondaryButton
            isSmall
            testID={tID('AssignmentList-addActivityButton')}
            onPress={addActivityHandler}
            text={intl.formatMessage({
              defaultMessage: 'Add activity',
              description: 'Button to add a new activity',
            })}
          />
        </AssignmentsNoneButtonContainer>
      )}
    </AssignmentsNoneContainer>
  )
}

export interface AssignmentsNoneProps {
  addActivityHandler?: () => void | null
  noDataText?: string
}
